package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/roblox". Pulls the REAL cached analysis from PROD. */
@Page("/isitsafe/roblox")
@Composable
fun RobloxReviewPage() {
    PublicReviewPage(
        slug = "roblox",
        blurb = "Is Roblox safe, and is it haram? Fitrah Filter checks Roblox against Islamic values, from chat-safety concerns to the deeper content questions parents ask.",
    )
}
